/* Pre-launch page: the ENTER control reveals the Shopify storefront password form. */
(function () {
  var toggle = document.querySelector('[data-password-toggle]');
  var gate = document.getElementById('storefront-password');
  if (!toggle || !gate) return;

  if (document.querySelector('.prelaunch__error')) gate.hidden = false;

  toggle.addEventListener('click', function () {
    var open = gate.hidden;
    gate.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    if (open) {
      var field = gate.querySelector('input[type="password"]');
      if (field) field.focus();
    }
  });
})();

/* Pre-launch capture. Full-page POST; the success state is rendered from
   ?subscribed=1 on the way back, and the control gets an immediate pending
   state on the way out. (K P0-1) */
(function () {
  var C = window.CMCapture;
  var form = document.getElementById('prelaunch-form');
  if (!C || !form) return;

  var status = form.querySelector('[data-prelaunch-status]');
  var fields = form.querySelector('[data-prelaunch-fields]');
  var button = form.querySelector('[data-prelaunch-submit]');
  var email = form.querySelector('input[type="email"]');

  if (C.subscribed()) {
    C.consume();
    if (fields) fields.remove();
    if (status) status.textContent = 'You are on the list.';
    return;
  }

  C.bind(form, {
    validate: function () {
      if (!email) return null;
      return email.checkValidity() ? null : 'Enter a valid email address';
    },
    onSending: function () {
      if (status) status.textContent = '';
      C.pending(button);
    },
    onError: function (message) {
      C.restore(button);
      if (status) status.textContent = message;
    }
  });
})();
